module.exports = __webpack_public_path__ + "static/export1-min-1b4c3c610068aaf880bd21099d07823f.png";